import type { ConversationEntityType } from "./EntityAvatar.types";

/** Max options visible at once; longer lists page in groups of this size (spec 0021, D44). */
export const CHOICES_PAGE_SIZE = 4;

export interface ChoiceOption {
  /** Stable identifier for the option. */
  id: string;
  /** Visible option text (this is what is sent as the user's answer). */
  label: string;
  /** Secondary line that tells look-alike options apart (e.g. context and created date). */
  description?: string | null;
  /** Roster entity type; when set, the option shows the matching avatar. */
  entity_type?: ConversationEntityType | null;
}

export interface ChoicesData {
  /** Question or instruction shown above the options. */
  prompt: string;
  /** The selectable options. Any count; the UI shows CHOICES_PAGE_SIZE per page. */
  options: ChoiceOption[];
  /** "single" renders one-choice buttons; "multi" renders checkboxes + a send button. */
  select_mode?: "single" | "multi";
}
